import { ComponentPropsWithRef } from "react";

export const HamburgerIcon = (props: ComponentPropsWithRef<"svg">) => (
  <svg
    height="17"
    width="20"
    viewBox="0 0 20 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    ref={props.ref}
    {...props}
  >
    <rect width="20" height="3" rx="1" fill="currentColor" />
    <rect y="7" width="20" height="3" rx="1" fill="currentColor" />
    <rect y="14" width="20" height="3" rx="1" fill="currentColor" />
  </svg>
);
